import * as TYPES from "./mutation-types";

export default {
  [TYPES.SET_MAIL_TO](state, value) {
    state.mailTo = value;
  },
  [TYPES.SET_BRANDS](state, value) {
    state.brands = value;
  },
  [TYPES.SET_MODELS](state, value) {
    state.models = value;
  },
  [TYPES.SET_YEARS](state, value) {
    state.years = value;
  },
  [TYPES.SET_GENERATIONS](state, value) {
    state.generations = value;
  },
  [TYPES.SET_BODIES](state, value) {
    state.bodies = value;
  },
  [TYPES.SET_GEARS](state, value) {
    state.gears = value;
  },
  [TYPES.SET_DRIVES](state, value) {
    state.drives = value;
  },
  [TYPES.SET_ENGINES](state, value) {
    state.engines = value;
  },
  [TYPES.SET_MODIFICATIONS](state, value) {
    state.modifications = value;
  },
  [TYPES.SET_COLORS](state, value) {
    state.colors = value;
  },
  [TYPES.SET_WHEELS](state, value) {
    state.wheels = value;
  },
  [TYPES.SET_STATES](state, value) {
    state.states = value;
  },
  [TYPES.SET_PTS](state, value) {
    state.pts = value;
  },
  [TYPES.SET_REGIONS](state, value) {
    state.regions = value;
  },
  [TYPES.SET_MODIFICATION](state, value) {
    state.modification = value;
  },
  [TYPES.SET_FETCHING](state, { key, value }) {
    state.fetching[key] = value;
  },
};
